export const AnomalyPathName = {
  ANOMALY_ALL: 'anomalyall',
};
